//Council
const CouncilModule = () => import('@pages/management/council/CouncilModule')
const CouncilIndex = () => import('@pages/management/council/CouncilIndex')
const CouncilMembers = () => import('@pages/management/council/CouncilMembers')
const CouncilDocumentIndex = () =>
    import('@pages/management/council/CouncilDocumentIndex')
const CouncilTaskIndex  = () =>
import('@pages/management/council/CouncilTaskIndex')
const CouncilMeetings = () =>
    import('@pages/management/council/CouncilMeetings')
const CouncilManagement = () =>
    import('@pages/management/council/CouncilManagement')
const CouncilReports = () => import('@pages/internals/management/InternalCouncilReports')

export default {
    path: 'council',
    component: CouncilModule,
    children: [{
            path: '/',
            component: CouncilIndex,
            name: 'council',
        },
        {
            path: 'members',
            component: CouncilMembers,
            name: 'councilMembers',
            props: true,
        },
        {
            path: 'documents',
            component: CouncilDocumentIndex,
            name: 'councilDocuments',
        },
        {
            path: 'tasks',
            component: CouncilTaskIndex,
            name: 'councilTasks',
        },
        {
            path: 'meetings',
            component: CouncilMeetings,
            name: 'councilMeetings',
        },
        {
            path: 'management',
            component: CouncilManagement,
            name: 'councilManagement',
        },
        {
            path: 'reports',
            component: CouncilReports,
            name: 'councilReports',
        }
    ],
}
